"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const node_1 = require("../common/node");
const cssGenerator_1 = require("./cssGenerator");
const jsonGenerator_1 = require("./jsonGenerator");
/**
 * Code generation for theme builder.
 * @category Generators
 */
class Code extends node_1.Node {
    constructor(ds) {
        super("code", ds);
        this.cssGenerator = new cssGenerator_1.CSSGenerator(ds);
        this.jsonGenerator = new jsonGenerator_1.JSONGenerator(ds);
        this.addDependency(ds.atoms);
    }
    generate() {
        this.cssGenerator.generate();
    }
    /**
     * Get all CSS variables for this design system.
     * @returns All CSS variables for this design system.
     */
    getCSSVars() {
        return this.cssGenerator.getVars();
    }
    /**
     * Set a CSS variable listener which is called each time a CSS variable value is changed.
     * @param name The listener name.
     * @param listener The listener callback.
     */
    setCSSVarListener(name, listener) {
        this.cssGenerator.setCSSVarListener(name, listener);
    }
    /**
     * Get a group of CSS variables associated with a particular node (i.e. atom, molecule, or organism).
     * @param node The node for which we are getting the group of variables.
     * @returns The variable group
     */
    getCSSVarGroup(node) {
        return this.cssGenerator.getVarGroup(node.key);
    }
    /**
     * Get all keys of all CSS variable groups.
     * @returns All keys associated with all CSS variable groups.
     */
    getCSSVarGroupKeys() {
        return this.cssGenerator.getVarGroupKeys();
    }
    /**
     * Get the base JSON code generated by the theme builder for the default theme.
     * @returns The JSON object.
     */
    getJSONBase() {
        return this.jsonGenerator.getJSONBase();
    }
    /**
     * Get the lightmode JSON code generated by the theme builder for the default theme.
     * @returns The JSON object.
     */
    getJSONLM() {
        return this.jsonGenerator.getJSONLM();
    }
    /**
     * Get the darkmode JSON code generated by the theme builder for the default theme.
     * @returns The JSON object.
     */
    getJSONDM() {
        return this.jsonGenerator.getJSONDM();
    }
    /**
     * Get the JSON code generated by the theme builder for the default theme for light or dark mode.
     * @returns The JSON object.
     */
    getJSON(lm) {
        return this.jsonGenerator.getJSON(lm);
    }
}
exports.Code = Code;
